import _merge from 'lodash/merge'

const theme = (params = {}) => {
    let t = {
        id: 'modern',
        fonts: {
            primary: { family: 'Roboto', params: '' },
            secondary: { family: 'Raleway', params: '' },
        },
        colors: {
            default: '#212121',
            muted: '#868e96',
            primary: '#7ba835',
            secondary: '#354050',
        },
        sizes: {
            small: '.7rem',
            default: '.875rem',
            lead: '1.00rem',
            subheading: '1.15rem',
            heading: '1.5rem',
        },
        backgrounds: {
            body: '#ffffff',
            header: '#ffffff',
            page: 'transparent',
            group: 'transparent',
            element: '#ffffff',
            options: 'transparent',
            calculated: '#ffffff',
            footer: '#ffffff',
            sidebar: '#ffffff',
            confirm: '#ffffff',
            popup: '#ffffff',
            auth: '#ffffff',
        },
        borders: {
            header: { width: '1px', color: '#ced4da' },
            page: { width: '1px', color: 'transparent', radius: '0rem' },
            group: { width: '1px', color: 'transparent', radius: '0rem' },
            element: { width: '1px', color: '#ced4da', radius: '.25rem' },
            options: { width: '0px', color: 'transparent', radius: '0rem' },
            calculated: { width: '1px', color: '#ced4da', radius: '.25rem' },
            footer: { width: '1px', color: '#ced4da' },
            sidebar: { width: '1px', color: '#ced4da' },
            confirm: { width: '1px', color: '#ced4da', radius: '0rem' },
            popup: { width: '1px', color: '#ced4da', radius: '0rem' },
            auth: { width: '1px', color: '#ced4da', radius: '0rem' },
            button: { width: '1px', color: 'transparent', radius: '0rem' },
        },
        auth: {
            info: true,
            image: true,
            font: 'primary',
            size: 'subheading',
            color: 'primary'
        },
        header: {
            enabled: true,
            fixed: true,
            font: 'secondary',
            size: 'heading',
            color: 'primary'
        },
        popup: {
            image: true,
            font: 'primary',
            size: 'default',
            color: 'muted',
        },
        sidebar: {
            enabled: true,
            info: true,
            image: true,
            font: 'primary',
            size: 'subheading',
            color: 'default'
        },
        footer: {
            fixed: false,
            progress: true,
            confirm: false,
            font: 'primary',
            size: 'lead',
            color: 'primary'
        },
        confirm: {
            enabled: true,
            font: 'primary',
            size: 'lead',
            color: 'default'
        },
        groups: {
            title: {
                font: 'secondary',
                size: 'heading',
                color: 'primary'
            },
            description: {
                font: 'primary',
                size: 'lead',
                color: 'muted',
            },
            rows: {
                font: 'secondary',
                size: 'subheading',
                color: 'muted',
            }
        },
        elements: {
            title: {
                font: 'primary',
                size: 'default',
                color: 'muted',
            },
            description: {
                font: 'primary',
                size: 'small',
                color: 'muted',
            },
            input: {
                font: 'primary',
                size: 'default',
                color: 'default'
            },
            options: {
                font: 'primary',
                size: 'default',
                color: 'default'
            },
            calculated: {
                font: 'primary',
                size: 'default',
                color: 'default'
            },
            highlight: false,
        },
        print: {
            colors: {
                default: '#212121',
                muted: '#cccccc',
                primary: '#666666',
                secondary: '#999999',
            },
            sizes: {
                small: '10pt',
                default: '13pt',
                lead: '16pt',
                subheading: '18pt',
                heading: '20pt',
            },
            breaks: {
                pages: 'always',
                groups: 'avoid',
            },
            pages: {
                title: {
                    size: 'heading',
                    color: 'secondary',
                }
            },
            groups: {
                title: {
                    size: 'subheading',
                    color: 'primary',
                },
                description: {
                    size: 'default',
                    color: 'muted',
                },
                rows: {
                    size: 'subheading',
                    color: 'secondary',
                }
            },
            elements: {
                title: {
                    size: 'default',
                    color: 'primary',
                },
                description: {
                    size: 'small',
                    color: 'muted',
                },
                input: {
                    size: 'default',
                    color: 'default',
                }
            }
        }
    }

    return _merge(t, params)
}

const template = (params = {}) => {
    let t = Object.assign({
        id: null,
        title: null,
        translations: {},
        options: {},
        confirmation: null,
        panels: [],
        groups: [],
        elements: [],
        package: [],
    }, params)

    if (t.package) {
        let ds = t.package.find(i => i.id == 'docusign')
        if (ds && ds.hasOwnProperty('value') && (ds.value == 'true' || ds.value == 'false')) {
            let enabled = ds.value == 'true'
            t.groups = t.groups.filter(g => {
                if (g.hasOwnProperty('docusign_visibility') && (g.docusign_visibility === true || g.docusign_visibility === false)) {
                    if (g.docusign_visibility !== enabled) {
                        t.elements = t.elements.filter(e => e.group !== g.id)
                        return false
                    }
                }
                return true
            })
        }
    }

    return t
}

const info = (params = {}) => {
    return Object.assign({
        company: {
            name: null,
            email: null,
            phone: null,
            logo: null,
            language: null,
            currency: null,
            timezone: null,
            security: null,
        },
        user: {
            name: null,
            email: null,
            phone: null,
            logo: null,
        }
    }, params)
}

const member = (params = {}) => {
    if (params.phone == null) { delete params.phone }
    return Object.assign({
        first_name: null,
        last_name: null,
        name: null,
        type: null,
        active: null,
        email: null,
        phone: { code: null, number: null, country: null },
        security: null,
        account: null,
        coclient: false,
        exists: false,
        code: null,
        signer: null,
    }, params)
}

const panel = (params = {}) => {
    return Object.assign({
        id: null,
        type: null,
    }, params)
}

const group = (params = {}) => {
    return Object.assign({
        id: null,
    }, params)
}

const element = (params = {}) => {
    return {
        id: params.hasOwnProperty('id') ? params.id : null,
        panel: params.hasOwnProperty('panel') ? params.panel : null,
        group: params.hasOwnProperty('group') ? params.group : null,
        definition: params.hasOwnProperty('definition') ? params.definition : null,
        value: params.hasOwnProperty('value') ? params.value : null,
        invalid: params.hasOwnProperty('invalid') ? params.invalid : false,
        valid: params.hasOwnProperty('valid') ? params.valid : true,
        exists: params.hasOwnProperty('exists') ? params.exists : true
    }
}

const signature = (params = {}) => {
    return {
        id: params.hasOwnProperty('id') ? params.id : null,
        panel: params.hasOwnProperty('panel') ? params.panel : null,
        group: params.hasOwnProperty('group') ? params.group : null,
        definition: params.hasOwnProperty('definition') ? params.definition : null,
        value: params.hasOwnProperty('value') ? params.value : null,
        name: params.hasOwnProperty('name') ? params.name : null,
        email: params.hasOwnProperty('email') ? params.email : null,
        ip: params.hasOwnProperty('ip') ? params.ip : null,
        signed_at: params.hasOwnProperty('signed_at') ? params.signed_at : null,
        filename: params.hasOwnProperty('filename') ? params.filename : null,
    }
}

export default { theme, template, info, member, panel, group, element, signature }
